import { httpClient } from '../http';
import { environmentBuilder } from '../../core/helpers/environmentBuilder';
import { AppDefaultValuesEnum } from '../../core/constants/appDefaultValues';

class TranslationService {
  constructor({ url }) {
    this.url = url;
  }

  async getTranslations(request) {
    const { applicationId, ...params } = request;
    const {
      data: { result },
    } = await httpClient.get(this.url, {
      params,
      headers: { applicationId },
    });
    if (result) {
      return result;
    }
    const {
      data: { result: defaultTranslations },
    } = await httpClient.get(this.url, {
      params,
      headers: { applicationId: AppDefaultValuesEnum.APPLICATION_ID },
      code: AppDefaultValuesEnum.LANGUAGE,
    });
    return defaultTranslations;
  }
}

const { httpTranslationUrl } = environmentBuilder();

export const translationService = new TranslationService({ url: httpTranslationUrl });
